/**
 * E4-4: Persist last successful post metadata per presentation (localStorage until backend field exists).
 */

export const POST_TOOLTIP_NO_CHANNEL = 'Connect a social account in Settings';
export const POST_TOOLTIP_NO_SLIDES = 'Add at least one slide before posting';

export const PRESENTATION_PUBLISH_STORAGE_PREFIX = 'brazn.presentationPublish.';

export type LastPublishMeta = {
  channelName: string;
  postedAt: string;
  postUrl?: string | null;
};

export function readLastPublish(presentationId: string): LastPublishMeta | null {
  if (typeof window === 'undefined' || !presentationId) return null;
  try {
    const raw = window.localStorage.getItem(`${PRESENTATION_PUBLISH_STORAGE_PREFIX}${presentationId}`);
    if (!raw) return null;
    const o = JSON.parse(raw) as LastPublishMeta;
    if (!o?.channelName || !o?.postedAt) return null;
    return o;
  } catch {
    return null;
  }
}

export function writeLastPublish(presentationId: string, meta: LastPublishMeta): void {
  if (typeof window === 'undefined' || !presentationId) return;
  try {
    window.localStorage.setItem(
      `${PRESENTATION_PUBLISH_STORAGE_PREFIX}${presentationId}`,
      JSON.stringify(meta)
    );
  } catch {
    /* quota or private mode */
  }
}

/** Compact relative label for "Last posted …" (no extra deps). */
export function formatPostedAgo(iso: string): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const diff = Date.now() - t;
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hour${h === 1 ? '' : 's'} ago`;
  const d = Math.floor(h / 24);
  return `${d} day${d === 1 ? '' : 's'} ago`;
}
